import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';

@Component({selector: 'confirm-dialog', templateUrl: './confirm-dialog.html'})
export class ConfirmDialogComponent {
  constructor(
      public dialogRef: MatDialogRef<ConfirmDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/dialogs/confirm/confirm.dialog.component.ts